/* eslint-disable prefer-rest-params */
import { VTooltip } from 'v-tooltip';
import '@/directives/tooltip/tooltip.vue';

VTooltip.options.defaultClass = 'pendo-tooltip';
VTooltip.options.defaultBoundariesElement = 'viewport';
VTooltip.options.defaultHtml = false;

export function buildClassList ({ classes, multiline, arrow, theme }) {
    const classList = ['pendo-tooltip'];
    if (typeof classes === 'string') {
        classList.push(...classes.split(' '));
    }

    if (Array.isArray(classes)) {
        classList.push(...classes);
    }

    if (multiline) {
        classList.push('is-multi-line');
    }

    if (arrow) {
        classList.push('has-tooltip-arrow');
    }

    if (theme) {
        classList.push(`pendo-tooltip--${theme}`);
    }

    return [...new Set(classList)];
}

// extend the default bind function for caret enable/disable functionality
const bind = (function (unboundFn) {
    return function (el, { value }) {
        if (typeof value !== 'object') {
            return unboundFn(...arguments);
        }

        if (value.offset == null) {
            value.offset = 8;
        }

        value.classes = buildClassList(value).join(' ');

        if (value.disposeTimeout) {
            VTooltip.options.disposeTimeout = value.disposeTimeout;
        } else {
            VTooltip.options.disposeTimeout = 2000;
        }

        return unboundFn(...arguments);
    };
})(VTooltip.bind);

export const PendoTooltip = {
    ...VTooltip,
    bind,
    update: bind
};

export default PendoTooltip;
